import { Tooltip } from '@components/ui/Tooltip';
import { getItemTooltip } from '@helpers/items';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';
import { useId } from 'react';

export function CraftingResources({ crafting }: { crafting: Shared.Crafting }) {
  const id = useId();
  const { userData } = useAppStore();

  const getItemAmount = (itemKey: string) => {
    return userData.items.find(i => i.key === itemKey)?.amount || 0;
  };

  return (
    <div className="crafting-grid">
      {Object.entries(crafting.resources).map(([resource, amount]) => (
        <div key={`${id}${resource}`}>
          <Tooltip overlay={getItemTooltip(resource)}>
            <div className="crafting-resource-img-container">
              <img src={`/assets/items/${resource}.avif`} alt={resource} />
            </div>
          </Tooltip>
          <p className={getItemAmount(resource) >= amount ? 'text-green-300' : ''}>
            {getItemAmount(resource)}/{amount}
          </p>
        </div>
      ))}
    </div>
  );
}